import React, { lazy, Suspense } from "react"
import SEO from "../components/seo"
import Layout from '../containers/layout/layout'
import Header from '../containers/layout/header/header-one'
import Footer from '../containers/layout/footer/footer-one'
import Hero from '../containers/infotechno/hero'
import AboutArea from '../containers/infotechno/about-area'
import ServicesArea from '../containers/infotechno/services-area'
import AboutServiceWrap from '../containers/infotechno/about-service-wrap'

// Lazy load below-the-fold components
const FunFactArea = lazy(() => import('../containers/global/funfact-area/section-two'))
const CaseStudyArea = lazy(() => import('../containers/infotechno/case-study-area'))
const TestimonialArea = lazy(() => import('../containers/global/testimonial-area/section-two'))
const GradiationArea = lazy(() => import('../containers/index-services/gradiation-area'))
const BlogArea = lazy(() => import('../containers/infotechno/blog-area'))
const ClientsArea = lazy(() => import('../containers/global/clients-area/section-one'))
const ContactArea = lazy(() => import('../containers/infotechno/contact-area'))

export const Head = () => (
  <SEO
    title="Your Reliable Technology Partner"
    description="Whether you need team augmentation, technical consulting, or full-service product development, we're here to create whatever you can dream up."
    image="/dark-logo.png"
    pathname="/"
  />
)

const Index = ({ location }) => {
  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <Hero />

        <AboutServiceWrap>
          <AboutArea />
          <ServicesArea />
        </AboutServiceWrap>
        <Suspense fallback={<div style={{ minHeight: '200px' }} />}>
          <FunFactArea />
          <CaseStudyArea />
          <TestimonialArea />
          <GradiationArea />
          <BlogArea />
          <ClientsArea />
          <ContactArea />
        </Suspense>
      </main>
      <Footer />
    </Layout>
  )
}

export default Index; 